import {Component} from '@angular/core';


@Component({
  templateUrl: 'info.html'
})
export class InfoPage {

}



// WEBPACK FOOTER //
// ./src/pages/info/info.ts